<app-portal-detail-drawer
    *ngIf="counterpartDetailService.counterpartDetailsObservable$ | async"
    variant="task"
    [drawerTitle]="drawerTitle()"
    [resetScrollKey]="drawerResetKey()"
    (backClick)="handleBackClick()"
    (closeClick)="counterpartDetailService.closeDrawer()">
    <ng-container *ngIf="isDetailView(); else counterpartFormState">
        <div class="counterpart-redesign">
            <div class="counterpart-redesign__header">
                <div class="counterpart-redesign__title">
                    <span>COUNTERPARTY</span>
                    <strong>{{ counterpartName() }}</strong>
                    <span class="counterpart-type-pill">{{ counterpartTypeLabel() }}</span>
                </div>
                <div class="counterpart-redesign__actions">
                    <button
                        type="button"
                        class="pill-action"
                        (click)="editCounterpart()">
                        <mat-icon>edit</mat-icon>
                        <span>Edit</span>
                    </button>
                    <button
                        type="button"
                        class="pill-action danger"
                        [disabled]="deletingCounterpart"
                        (click)="deleteCounterpart()">
                        <mat-icon>delete_outline</mat-icon>
                        <span>Delete</span>
                    </button>
                </div>
                <div class="breadcrumb-row">
                    <span>Fund Operation</span>
                    <span>/</span>
                    <span>Counterparties</span>
                    <span>/</span>
                    <strong>{{ counterpartSlug() }}</strong>
                </div>
            </div>

            <app-portal-detail-section
                title="Basic details"
                [open]="isSectionOpen('basic')"
                (toggle)="toggleSection('basic')">
                <div class="counterpart-detail-list">
                    <div class="counterpart-detail-row" *ngFor="let item of convertObjectToArray(basicDetails || {})">
                        <span>{{ item.key }}</span>
                        <strong>{{ valueOrDash(item.value) }}</strong>
                    </div>
                </div>
            </app-portal-detail-section>

            <app-portal-detail-section
                title="Contact Person"
                [open]="isSectionOpen('contacts')"
                (toggle)="toggleSection('contacts')">
                <span portalDetailSectionMeta class="section-count">{{ contacts.length }}</span>
                <div class="counterpart-section-actions">
                    <button type="button" class="add-section-btn" (click)="addContactHandler()">
                        <mat-icon>add_circle_outline</mat-icon>
                        <span>Add contact</span>
                    </button>
                </div>
                <ng-container *ngIf="!fetchingContacts; else detailsLoader">
                    <div class="counterpart-card-list" *ngIf="contacts.length; else emptyContacts">
                        <div class="counterpart-info-card" *ngFor="let item of contacts">
                            <div class="counterpart-info-card__avatar">
                                {{ ((item.firstName || '')[0] || '') + ((item.lastName || '')[0] || '') || '-' }}
                            </div>
                            <div class="counterpart-info-card__body">
                                <div class="counterpart-info-card__title">
                                    <strong>{{ item.firstName }} {{ item.lastName }}</strong>
                                    <span class="counterpart-badge" *ngIf="item.is_default">Primary</span>
                                </div>
                                <span *ngIf="item.emailAddress">{{ item.emailAddress }}</span>
                                <span *ngIf="item.phoneNumber">{{ item.phoneNumber }}</span>
                            </div>
                            <button type="button" class="counterpart-icon-btn" [matMenuTriggerFor]="contactMenu">
                                <mat-icon>more_horiz</mat-icon>
                            </button>
                            <mat-menu class="counterpart-mat-menu" #contactMenu="matMenu" xPosition="before" counterpart-detail-action-position>
                                <button *ngIf="!item.is_default" mat-menu-item type="button" (click)="makePrimaryContact(item); $event.preventDefault()">
                                    <mat-icon>person</mat-icon>
                                    <span>Make primary</span>
                                </button>
                                <button mat-menu-item type="button" (click)="editContact(item); $event.preventDefault()">
                                    <mat-icon>edit</mat-icon>
                                    <span>Edit</span>
                                </button>
                                <button *ngIf="!item.is_default" mat-menu-item type="button" (click)="deleteContact(item.id); $event.preventDefault()">
                                    <mat-icon>delete_outline</mat-icon>
                                    <span>Delete</span>
                                </button>
                            </mat-menu>
                        </div>
                    </div>
                    <ng-template #emptyContacts>
                        <div class="counterpart-empty-state">No contact person added yet.</div>
                    </ng-template>
                </ng-container>
            </app-portal-detail-section>

            <app-portal-detail-section
                title="VAT IDs"
                [open]="isSectionOpen('vat')"
                (toggle)="toggleSection('vat')">
                <span portalDetailSectionMeta class="section-count">{{ vatIds.length }}</span>
                <div class="counterpart-section-actions">
                    <button type="button" class="add-section-btn" (click)="addVatIdsHandler()">
                        <mat-icon>add_circle_outline</mat-icon>
                        <span>Add VAT ID</span>
                    </button>
                </div>
                <ng-container *ngIf="!fetchingVatIds; else detailsLoader">
                    <div class="counterpart-card-list" *ngIf="vatIds.length; else emptyVatIds">
                        <div class="counterpart-info-card" *ngFor="let item of vatIds">
                            <mat-icon class="counterpart-info-card__icon">percent</mat-icon>
                            <div class="counterpart-info-card__body">
                                <strong>{{ item.value }}</strong>
                                <span>{{ item.countryName }}</span>
                            </div>
                            <button type="button" class="counterpart-icon-btn" [matMenuTriggerFor]="vatIdMenu">
                                <mat-icon>more_horiz</mat-icon>
                            </button>
                            <mat-menu class="counterpart-mat-menu" #vatIdMenu="matMenu" xPosition="before" counterpart-detail-action-position>
                                <button mat-menu-item type="button" (click)="editVatId(item); $event.preventDefault()">
                                    <mat-icon>edit</mat-icon>
                                    <span>Edit</span>
                                </button>
                                <button mat-menu-item type="button" (click)="deleteVatId(item.id); $event.preventDefault()">
                                    <mat-icon>delete_outline</mat-icon>
                                    <span>Delete</span>
                                </button>
                            </mat-menu>
                        </div>
                    </div>
                    <ng-template #emptyVatIds>
                        <div class="counterpart-empty-state">No VAT IDs added yet.</div>
                    </ng-template>
                </ng-container>
            </app-portal-detail-section>

            <app-portal-detail-section
                title="Bank Accounts"
                [open]="isSectionOpen('bank')"
                (toggle)="toggleSection('bank')">
                <span portalDetailSectionMeta class="section-count">{{ bankAccounts.length }}</span>
                <div class="counterpart-section-actions">
                    <button type="button" class="add-section-btn" (click)="addBankAccountHandler()">
                        <mat-icon>add_circle_outline</mat-icon>
                        <span>Add bank account</span>
                    </button>
                </div>
                <ng-container *ngIf="!fetchingBankAccounts; else detailsLoader">
                    <div class="counterpart-card-list" *ngIf="bankAccounts.length; else emptyBankAccounts">
                        <div class="counterpart-info-card" *ngFor="let item of bankAccounts">
                            <mat-icon class="counterpart-info-card__icon">account_balance</mat-icon>
                            <div class="counterpart-info-card__body">
                                <div class="counterpart-info-card__title">
                                    <strong>{{ item.account_holder_name }}</strong>
                                    <span class="counterpart-badge" *ngIf="item.is_primary">Default</span>
                                </div>
                                <span>{{ item.iban }}</span>
                                <span *ngIf="item.bic">{{ item.bic }}</span>
                            </div>
                            <button type="button" class="counterpart-icon-btn" [matMenuTriggerFor]="accountMenu">
                                <mat-icon>more_horiz</mat-icon>
                            </button>
                            <mat-menu class="counterpart-mat-menu" #accountMenu="matMenu" xPosition="before" counterpart-detail-action-position>
                                <button *ngIf="!item.is_primary" mat-menu-item type="button" (click)="makePrimaryAccount(item); $event.preventDefault()">
                                    <mat-icon>flag</mat-icon>
                                    <span>Set as default</span>
                                </button>
                                <button mat-menu-item type="button" (click)="editBankAccount(item); $event.preventDefault()">
                                    <mat-icon>edit</mat-icon>
                                    <span>Edit</span>
                                </button>
                                <button *ngIf="!item.is_primary" mat-menu-item type="button" (click)="deleteBankAccount(item.id); $event.preventDefault()">
                                    <mat-icon>delete_outline</mat-icon>
                                    <span>Delete</span>
                                </button>
                            </mat-menu>
                        </div>
                    </div>
                    <ng-template #emptyBankAccounts>
                        <div class="counterpart-empty-state">No bank accounts added yet.</div>
                    </ng-template>
                </ng-container>
            </app-portal-detail-section>
        </div>
    </ng-container>

    <ng-template #counterpartFormState>
        <ng-container *ngIf="isCreate; else nestedCounterpartForms">
            <form #createCounterpartForm="ngForm" class="counterpart-form" (change)="createCounterpartForm.control.markAsTouched()">
                <div class="counterpart-form__header">
                    <span>COUNTERPARTY</span>
                    <strong>{{ editForm ? counterpartName() : 'New counterparty' }}</strong>
                    <span class="counterpart-type-pill">{{ editForm ? 'Editing details' : 'Create record' }}</span>
                </div>

                <app-portal-detail-section
                    title="Basic details"
                    [open]="isSectionOpen('basic')"
                    (toggle)="toggleSection('basic')">
                    <div class="counterpart-type-toggle">
                        <input [(ngModel)]="createCounterpart.type" name="type" type="text" hidden>
                        <button
                            type="button"
                            [class.active]="createCounterpart.type === 'organization'"
                            (click)="createCounterpart.type = 'organization'; createCounterpartForm.form.markAsTouched()">
                            <mat-icon>{{ createCounterpart.type === 'organization' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
                            <span>Legal entity</span>
                        </button>
                        <button
                            type="button"
                            [class.active]="createCounterpart.type === 'individual'"
                            (click)="createCounterpart.type = 'individual'; createCounterpartForm.form.markAsTouched()">
                            <mat-icon>{{ createCounterpart.type === 'individual' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
                            <span>Private individual</span>
                        </button>
                    </div>

                    <div class="counterpart-form-grid">
                        <div class="counterpart-field full">
                            <label>{{ createCounterpart.type === 'organization' ? 'Company name' : 'Individual name' }} <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createCounterpart.name"
                                (ngModelChange)="createCounterpartForm.form.markAsTouched()"
                                [class.error]="name.invalid && name.touched"
                                name="name"
                                #name="ngModel"
                                type="text"
                                placeholder="Enter a name"
                                required>
                            <div class="counterpart-error" *ngIf="name.invalid && name.touched">Please enter name</div>
                        </div>

                        <div class="counterpart-field half">
                            <label>Phone</label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createCounterpart.phone"
                                (ngModelChange)="createCounterpartForm.form.markAsTouched()"
                                [class.error]="phone.invalid && phone.touched"
                                pattern="^[0-9]+$"
                                #phone="ngModel"
                                name="phone"
                                type="text"
                                placeholder="Enter phone number">
                            <div class="counterpart-error" *ngIf="phone.invalid && phone.touched">Please enter a valid phone number</div>
                        </div>

                        <div class="counterpart-field half">
                            <label>Email <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createCounterpart.email"
                                (ngModelChange)="createCounterpartForm.form.markAsTouched()"
                                [class.error]="email.invalid && email.touched"
                                #email="ngModel"
                                required
                                email
                                name="email"
                                type="email"
                                placeholder="Enter email address"
                                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$">
                            <div class="counterpart-error" *ngIf="email.invalid && email.touched">
                                {{ email.errors?.['required'] ? 'Please enter email' : 'Please enter a valid email' }}
                            </div>
                        </div>

                        <div class="counterpart-field full">
                            <label>TAX ID</label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createCounterpart.tax_id"
                                name="taxId"
                                type="text"
                                placeholder="Enter a valid Tax ID">
                        </div>
                    </div>
                </app-portal-detail-section>

                <app-portal-detail-section
                    title="Business address"
                    [open]="isSectionOpen('address')"
                    (toggle)="toggleSection('address')">
                    <div class="counterpart-form-grid">
                        <div class="counterpart-field full">
                            <label>Address line 1 <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createCounterpart.addressLine1"
                                (ngModelChange)="createCounterpartForm.form.markAsTouched()"
                                [class.error]="address1.invalid && address1.touched"
                                required
                                name="address1"
                                #address1="ngModel"
                                type="text"
                                placeholder="Enter address line 1">
                            <div class="counterpart-error" *ngIf="address1.invalid && address1.touched">Please enter address line 1</div>
                        </div>

                        <div class="counterpart-field full">
                            <label>Address line 2</label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createCounterpart.addressLine2"
                                (ngModelChange)="createCounterpartForm.form.markAsTouched()"
                                name="address2"
                                type="text"
                                placeholder="Enter address line 2">
                        </div>

                        <div class="counterpart-field half">
                            <label>City <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createCounterpart.city"
                                (ngModelChange)="createCounterpartForm.form.markAsTouched()"
                                [class.error]="city.invalid && city.touched"
                                name="city"
                                #city="ngModel"
                                type="text"
                                placeholder="eg. Berlin"
                                required>
                            <div class="counterpart-error" *ngIf="city.invalid && city.touched">Please enter city</div>
                        </div>

                        <div class="counterpart-field half">
                            <label>ZIP code <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createCounterpart.pincode"
                                (ngModelChange)="createCounterpartForm.form.markAsTouched()"
                                [class.error]="zipCode.invalid && zipCode.touched"
                                name="zipCode"
                                #zipCode="ngModel"
                                type="text"
                                placeholder="eg. 10176"
                                required>
                            <div class="counterpart-error" *ngIf="zipCode.invalid && zipCode.touched">Please enter ZIP code</div>
                        </div>

                        <div class="counterpart-field full">
                            <label>State / Area / Province <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createCounterpart.state"
                                (ngModelChange)="createCounterpartForm.form.markAsTouched()"
                                [class.error]="state.invalid && state.touched"
                                name="state"
                                #state="ngModel"
                                type="text"
                                placeholder="eg. Brandenburg"
                                required>
                            <div class="counterpart-error" *ngIf="state.invalid && state.touched">Please enter State / Area / Province</div>
                        </div>

                        <div class="counterpart-field full">
                            <label>Country <span>*</span></label>
                            <mat-form-field appearance="fill" class="counterpart-select-field">
                                <mat-select
                                    [(ngModel)]="createCounterpart.country"
                                    name="country"
                                    #country="ngModel"
                                    placeholder="Select a country"
                                    required>
                                    <mat-option class="create-counterpart-options small" *ngFor="let item of countries" [value]="item.value">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                            </mat-form-field>
                            <div class="counterpart-error" *ngIf="country.invalid && country.touched">Please select country</div>
                        </div>
                    </div>
                </app-portal-detail-section>

                <div class="counterpart-footer-actions portal-detail-sticky-actions">
                    <button type="button" class="cancel" (click)="editForm ? hideSubForms() : counterpartDetailService.closeDrawer()">Cancel</button>
                    <button
                        type="button"
                        class="submit"
                        *ngIf="!editForm"
                        [disabled]="createCounterpartForm.invalid || creatingCounterpart || !createCounterpartForm.touched"
                        (click)="createCounterpartHandler()">
                        <ng-container *ngIf="!creatingCounterpart; else spinner">Create</ng-container>
                    </button>
                    <button
                        type="button"
                        class="submit"
                        *ngIf="editForm"
                        [disabled]="createCounterpartForm.invalid || creatingCounterpart || !createCounterpartForm.touched"
                        (click)="updateCounterpartHandler()">
                        <ng-container *ngIf="!creatingCounterpart; else spinner">Update</ng-container>
                    </button>
                </div>
            </form>
        </ng-container>
    </ng-template>

    <ng-template #nestedCounterpartForms>
        <ng-container *ngIf="showContactForm">
            <form #createContactForm="ngForm" class="counterpart-form">
                <div class="counterpart-form__header">
                    <span>CONTACT</span>
                    <strong>{{ editForm ? (createContact.firstName + ' ' + createContact.lastName) : 'New contact person' }}</strong>
                </div>

                <app-portal-detail-section
                    title="Contact details"
                    [open]="isSectionOpen('contacts')"
                    (toggle)="toggleSection('contacts')">
                    <div class="counterpart-form-grid">
                        <div class="counterpart-field half">
                            <label>First name <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createContact.firstName"
                                (ngModelChange)="createContactForm.form.markAsTouched()"
                                [class.error]="contactFirstName.invalid && contactFirstName.touched"
                                name="contactFirstName"
                                #contactFirstName="ngModel"
                                required
                                type="text"
                                placeholder="Enter first name">
                            <div class="counterpart-error" *ngIf="contactFirstName.invalid && contactFirstName.touched">Please enter first name</div>
                        </div>

                        <div class="counterpart-field half">
                            <label>Last name <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createContact.lastName"
                                (ngModelChange)="createContactForm.form.markAsTouched()"
                                [class.error]="contactLastName.invalid && contactLastName.touched"
                                name="contactLastName"
                                #contactLastName="ngModel"
                                required
                                type="text"
                                placeholder="Enter last name">
                            <div class="counterpart-error" *ngIf="contactLastName.invalid && contactLastName.touched">Please enter last name</div>
                        </div>

                        <div class="counterpart-field full">
                            <label>Email <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createContact.emailAddress"
                                (ngModelChange)="createContactForm.form.markAsTouched()"
                                [class.error]="contactEmail.invalid && contactEmail.touched"
                                name="contactEmail"
                                #contactEmail="ngModel"
                                required
                                email
                                type="email"
                                placeholder="Enter email address"
                                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$">
                            <div class="counterpart-error" *ngIf="contactEmail.invalid && contactEmail.touched">
                                {{ contactEmail.errors?.['required'] ? 'Please enter email' : 'Please enter a valid email' }}
                            </div>
                        </div>

                        <div class="counterpart-field full">
                            <label>Phone</label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createContact.phoneNumber"
                                (ngModelChange)="createContactForm.form.markAsTouched()"
                                [class.error]="contactPhone.invalid && contactPhone.touched"
                                pattern="^[0-9]+$"
                                name="contactPhone"
                                #contactPhone="ngModel"
                                type="text"
                                placeholder="Enter phone number">
                            <div class="counterpart-error" *ngIf="contactPhone.invalid && contactPhone.touched">Please enter a valid phone number</div>
                        </div>

                        <div class="counterpart-checkbox full" *ngIf="(contacts.length && !editForm) || (!selectedContact?.is_default && editForm)">
                            <mat-checkbox
                                [(ngModel)]="createContact.is_default"
                                (ngModelChange)="createContactForm.form.markAsTouched()"
                                name="contactIsPrimary">
                                Set as primary
                            </mat-checkbox>
                        </div>
                    </div>
                </app-portal-detail-section>

                <div class="counterpart-footer-actions portal-detail-sticky-actions">
                    <button type="button" class="cancel" (click)="isAddContact ? counterpartDetailService.closeDrawer() : hideSubForms()">Cancel</button>
                    <button
                        type="button"
                        class="submit"
                        *ngIf="!editForm"
                        [disabled]="createContactForm.invalid || creatingContact || !createContactForm.touched"
                        (click)="createContactHandler()">
                        <ng-container *ngIf="!creatingContact; else spinner">Add contact</ng-container>
                    </button>
                    <button
                        type="button"
                        class="submit"
                        *ngIf="editForm"
                        [disabled]="createContactForm.invalid || creatingContact || !createContactForm.touched"
                        (click)="updateContactHandler()">
                        <ng-container *ngIf="!creatingContact; else spinner">Update</ng-container>
                    </button>
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="showVatIdForm">
            <form #createVatIdForm="ngForm" class="counterpart-form">
                <div class="counterpart-form__header">
                    <span>VAT ID</span>
                    <strong>{{ editForm ? createVatId.value : 'New VAT ID' }}</strong>
                </div>

                <app-portal-detail-section
                    title="VAT details"
                    [open]="isSectionOpen('vat')"
                    (toggle)="toggleSection('vat')">
                    <div class="counterpart-form-grid">
                        <div class="counterpart-field full">
                            <label>Country <span>*</span></label>
                            <mat-form-field appearance="fill" class="counterpart-select-field">
                                <mat-select
                                    [(ngModel)]="createVatId.country"
                                    name="vatCountry"
                                    #vatCountry="ngModel"
                                    required
                                    placeholder="Select a country">
                                    <mat-option class="create-counterpart-options" *ngFor="let item of countries" [value]="item.value">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                            </mat-form-field>
                            <div class="counterpart-error" *ngIf="vatCountry.invalid && vatCountry.touched">Please select country</div>
                        </div>

                        <div class="counterpart-field full">
                            <label>VAT Type <span>*</span></label>
                            <mat-form-field appearance="fill" class="counterpart-select-field">
                                <mat-select
                                    [(ngModel)]="createVatId.type"
                                    name="vatType"
                                    #vatType="ngModel"
                                    required
                                    placeholder="Select a type">
                                    <mat-option class="create-counterpart-options" *ngFor="let item of vatTypes" [value]="item.value">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                            </mat-form-field>
                            <div class="counterpart-error" *ngIf="vatType.invalid && vatType.touched">Please select type</div>
                        </div>

                        <div class="counterpart-field full">
                            <label>VAT ID <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createVatId.value"
                                (ngModelChange)="createVatIdForm.form.markAsTouched()"
                                [class.error]="vatId.invalid && vatId.touched"
                                name="vatId"
                                #vatId="ngModel"
                                required
                                type="text"
                                placeholder="Enter your VAT ID">
                            <div class="counterpart-error" *ngIf="vatId.invalid && vatId.touched">Please enter VAT ID</div>
                        </div>
                    </div>
                </app-portal-detail-section>

                <div class="counterpart-footer-actions portal-detail-sticky-actions">
                    <button type="button" class="cancel" (click)="hideSubForms()">Cancel</button>
                    <button
                        type="button"
                        class="submit"
                        *ngIf="!editForm"
                        [disabled]="createVatIdForm.invalid || creatingVatId || !createVatIdForm.touched"
                        (click)="createvatIdHandler()">
                        <ng-container *ngIf="!creatingVatId; else spinner">Add VAT ID</ng-container>
                    </button>
                    <button
                        type="button"
                        class="submit"
                        *ngIf="editForm"
                        [disabled]="createVatIdForm.invalid || creatingVatId || !createVatIdForm.touched"
                        (click)="updateVatIdHandler()">
                        <ng-container *ngIf="!creatingVatId; else spinner">Update</ng-container>
                    </button>
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="showBankAccountForm">
            <form #createBankAccountForm="ngForm" class="counterpart-form">
                <div class="counterpart-form__header">
                    <span>BANK ACCOUNT</span>
                    <strong>{{ editForm ? createBankAccount.account_holder_name : 'New bank account' }}</strong>
                </div>

                <app-portal-detail-section
                    title="Bank details"
                    [open]="isSectionOpen('bank')"
                    (toggle)="toggleSection('bank')">
                    <div class="counterpart-form-grid">
                        <div class="counterpart-field full">
                            <label>Account name <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createBankAccount.account_holder_name"
                                (ngModelChange)="createBankAccountForm.form.markAsTouched()"
                                [class.error]="accountName.invalid && accountName.touched"
                                name="accountName"
                                #accountName="ngModel"
                                required
                                type="text"
                                placeholder="Enter account name">
                            <div class="counterpart-error" *ngIf="accountName.invalid && accountName.touched">Please enter account name</div>
                        </div>

                        <div class="counterpart-field half">
                            <label>Account number</label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createBankAccount.accountNumber"
                                (ngModelChange)="createBankAccountForm.form.markAsTouched()"
                                name="accountNumber"
                                type="text"
                                placeholder="Enter account number">
                        </div>

                        <div class="counterpart-field half">
                            <label>Bank name</label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createBankAccount.bankName"
                                (ngModelChange)="createBankAccountForm.form.markAsTouched()"
                                name="bankName"
                                type="text"
                                placeholder="Enter bank name">
                        </div>

                        <div class="counterpart-field half">
                            <label>Bank location <span>*</span></label>
                            <mat-form-field appearance="fill" class="counterpart-select-field">
                                <mat-select
                                    [(ngModel)]="createBankAccount.country"
                                    name="location"
                                    #location="ngModel"
                                    required
                                    placeholder="Select a location">
                                    <mat-option class="create-counterpart-options" *ngFor="let item of countries" [value]="item.value">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                            </mat-form-field>
                            <div class="counterpart-error" *ngIf="location.invalid && location.touched">Please select location</div>
                        </div>

                        <div class="counterpart-field half">
                            <label>Currency <span>*</span></label>
                            <mat-form-field appearance="fill" class="counterpart-select-field">
                                <mat-select
                                    [(ngModel)]="createBankAccount.currency"
                                    name="currency"
                                    #currency="ngModel"
                                    required
                                    placeholder="Select a currency">
                                    <mat-option class="create-counterpart-options" *ngFor="let item of currencies" [value]="item.value">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                            </mat-form-field>
                            <div class="counterpart-error" *ngIf="currency.invalid && currency.touched">Please select currency</div>
                        </div>

                        <div class="counterpart-field full">
                            <label>IBAN <span>*</span></label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createBankAccount.iban"
                                (ngModelChange)="createBankAccountForm.form.markAsTouched()"
                                [class.error]="iban.invalid && iban.touched"
                                name="iban"
                                #iban="ngModel"
                                required
                                type="text"
                                placeholder="Enter IBAN">
                            <div class="counterpart-error" *ngIf="iban.invalid && iban.touched">Please enter IBAN</div>
                        </div>

                        <div class="counterpart-field full">
                            <label>SWIFT/BIC</label>
                            <input
                                class="counterpart-input"
                                [(ngModel)]="createBankAccount.bic"
                                (ngModelChange)="createBankAccountForm.form.markAsTouched()"
                                name="bic"
                                type="text"
                                placeholder="Enter SWIFT/BIC">
                        </div>

                        <div class="counterpart-checkbox full" *ngIf="(bankAccounts.length && !editForm) || (!selectedBankaccount?.is_primary && editForm)">
                            <mat-checkbox
                                [(ngModel)]="createBankAccount.is_primary"
                                name="isDefault"
                                (ngModelChange)="createBankAccountForm.form.markAsTouched()"
                                [disabled]="!bankAccounts.length && !editForm">
                                Set as default
                            </mat-checkbox>
                        </div>
                    </div>
                </app-portal-detail-section>

                <div class="counterpart-footer-actions portal-detail-sticky-actions">
                    <button type="button" class="cancel" (click)="hideSubForms()">Cancel</button>
                    <button
                        type="button"
                        class="submit"
                        *ngIf="!editForm"
                        [disabled]="createBankAccountForm.invalid || creatingBankAccount || !createBankAccountForm.touched"
                        (click)="createBankAccountHandler()">
                        <ng-container *ngIf="!creatingBankAccount; else spinner">Add bank</ng-container>
                    </button>
                    <button
                        type="button"
                        class="submit"
                        *ngIf="editForm"
                        [disabled]="createBankAccountForm.invalid || creatingBankAccount || !createBankAccountForm.touched"
                        (click)="updateBankaccountHandler()">
                        <ng-container *ngIf="!creatingBankAccount; else spinner">Update</ng-container>
                    </button>
                </div>
            </form>
        </ng-container>
    </ng-template>
</app-portal-detail-drawer>

<ng-template #spinner>
    <span class="loader"></span>
</ng-template>

<ng-template #detailsLoader>
    <div class="counterpart-skeleton-list">
        <div class="counterpart-skeleton-row" *ngFor="let number of [0, 1]">
            <div>
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '185px', height: '20px', marginBottom: 0 }"></ngx-skeleton-loader>
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '105px', height: '20px', marginBottom: 0 }"></ngx-skeleton-loader>
            </div>
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '24px', height: '24px', marginBottom: 0 }"></ngx-skeleton-loader>
        </div>
    </div>
</ng-template>
